import {InjectionToken} from '@angular/core';
import {ErrorHandlerOptions} from '../models';

export const errorHandlerOptionsToken = new InjectionToken<ErrorHandlerOptions>('S2WX_ERROR_HANDLER_OPTIONS');
